export default __webpack_public_path__ + "images/0xdcefd8c8fcc492630b943abcab3429f12ea9fea2.png";